export const PAGE = {
  swap: "/swap",
  faucet: "/faucet",
  home: "/",
  contact: "/contact",
  admin: "/admin",
  not_found: "404",
};
